import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=27619ad8"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"
import style0 from "./todo.vue?vue&type=style&index=0&id=27619ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports